import { useContext } from 'react';

import { ItemSetContext } from './item-set-provider';

function useItemSet() {
  const context = useContext(ItemSetContext);

  if (!context) {
    throw new Error('useItemSet must be used within a ItemSetProvider');
  }

  return context;
}

export { useItemSet };
